/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import BaseComponent from '../components/BaseCom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from "@fullcalendar/timegrid";
import Auth from '../shared/Auth';
import Globals from '../shared/Globals';
import LoadingAlert from '../components/LoadingAlert';
import { withParamsAndNavigate } from "../components/WithParamsAndNavigate";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { qreq } from '../shared/qrequest';
import { SidebarGlobal } from './_Sidebar';
import FormInput from './FormInput';
import './Calendar.css';
import Icon from './Icon';
import Alert from './Alert';

class Calendar extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            list: [],
            initialDate: null,
            cityList: [],
            distanceList: [
                { id: 10, name: '10 miles' },
                { id: 25, name: '25 miles' },
                { id: 50, name: '50 miles' },
                { id: 100, name: '100 miles' },
                { id: 200, name: '200 miles' },
                { id: 500, name: '500 miles' }
            ],
            filter: {},
            localFilter: {},
            initialView: null,
            calendarHeight: 'auto'
        };
        this.load = this.load.bind(this);
        this.loadDate = this.loadDate.bind(this);
        this.renderEventContent = this.renderEventContent.bind(this);
        this.onDatesSet = this.onDatesSet.bind(this);
        this.eventClick = this.eventClick.bind(this);
        this.resize = this.resize.bind(this);
        this.isFilter = this.isFilter.bind(this);
        this.search = this.search.bind(this);
        this.loadLegend = this.loadLegend.bind(this);
    }

    componentDidMount() {
        this.loadDate();
        SidebarGlobal.setSubNav(<div className="btn-group">
            {Auth.hasRole('manager') ? <Link to="/schedule/new" className="btn btn-primary"><FontAwesomeIcon icon={fa.faHandHoldingMedical} /> <span className="d-none d-md-inline">New Encounter</span></Link> : null}
            {Auth.hasRole('sales') ? <Link to="/schedule/new/event" className="btn btn-primary"><FontAwesomeIcon icon={fa.faCalendarPlus} /> <span className="d-none d-md-inline">New Event</span></Link> : null}
            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showFilter: !this.state.showFilter })}><FontAwesomeIcon icon={fa.faFilter} /> <span className="d-none d-md-inline">Filter</span></button>
        </div>);
        qreq.get('/api/visit/calendar/view', j => {
            if (j.item)
                this.setState({ initialView: j.item });
            else
                this.setState({ initialView: 'dayGridMonth' });
        }, () => {
            this.setState({ initialView: 'dayGridMonth' });
        });
        document.addEventListener('resize', this.resize);
        this.resize();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
        document.removeEventListener('resize', this.resize);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
            this.setState({ user: this.props.user });
    }

    resize() {
        if (this.isMobile())
            this.setState({ calendarHeight: window.innerHeight - 250 });
    }

    isFilter() {
        return this.state.showFilter || this.state.filter.city || this.state.filter.distance;
    }

    incMonth(dt) {
        try {
            var m = Number(dt.getUTCMonth());
            var y = Number(dt.getUTCFullYear());
            if (m >= 11) {
                dt.setUTCMonth(0);
                dt.setUTCFullYear(y + 1);
            }
            else
                dt.setMonth(m + 1);
        }
        catch (ex) {
            console.log('incMonth exception: ' + ex);
        }
    }

    loadDate() {
        qreq.get('/api/visit/calendar/date', j => {
            if (j.item) {
                var t = Date.parse(j.item);
                var dt = new Date(t);
                var edt = new Date(t);
                this.incMonth(edt);
                var now = new Date();
                if (now > dt && now < edt)
                    this.setState({ initialDate: new Date() });
                else
                    this.setState({ initialDate: new Date(Date.parse(Globals.toISOLocalDateString(dt))) });
            }
            else
                this.setState({ initialDate: new Date() });
        });
    }

    loadLegend(visits) {
        qreq.get('/api/user/list?roleName=medical&showDisabled=false', j => {
            if (j.list) {
                var list = [];
                j.list.forEach(i => {
                    var find = visits.find(a => a.assignedToUserID === i.id);
                    if (find)
                        list.push(i);
                });
                this.setState({ users: list });
            }
        });
    }

    load(startDate, endDate) {
        if (!startDate)
            startDate = new Date();
        if (!endDate) {
            endDate = new Date(startDate);
            var m = Number(endDate.getUTCMonth());
            var y = Number(endDate.getUTCFullYear());
            if (m >= 11)
                endDate.setUTCMonth(0).setUTCFullYear(y + 1);
            else
                endDate.setMonth(m + 1);
        }

        /*
        var now = new Date();
        if(now > startDate && now < endDate)
            this.setState({ initialDate: new Date() });
        */

        qreq.post('/api/visit/list', { startDate: Globals.toISODateString(startDate), endDate: Globals.toISODateString(endDate) }, j => {
            if (j.list) {
                Globals.processResultObject(j);
                var cityList = []
                j.list.forEach(i => {
                    if (i.isEncounter) {
                        if (i.patient.firstName && i.patient.lastName && i.patient.firstName.length >= 1)
                            i.title = i.patient.firstName.substr(0, 1) + '. ' + i.patient.lastName;
                        else
                            i.title = i.patient.name;
                    }
                    else
                        i.title = i.eventName;

                    i.start = new Date(i.scheduleDate);
                    i.end = new Date(i.scheduleDate);
                    i.end.setUTCHours(i.end.getUTCHours() + 1);
                    i.textColor = i.color;
                    i.color = 'rgba(225,225,225,0.5)';
                    i._id = i.id;
                    if (i.city) {
                        if (!cityList.find(a => a.id === i.city.trim().toUpperCase()))
                            cityList.push({ id: i.city.trim().toUpperCase(), name: this.capitalize(i.city), lat: i.lat, lng: i.lng });
                    }
                });

                cityList.sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                });
                this.setState({ list: j.list, originalList: j.list, cityList: cityList });
                Auth.getLogin(u => {
                    this.setState({ user: u });
                    if (Auth.hasRole('practitioner')) {
                        j.list.forEach(i => {
                            if (i.assignedToUserID === u.id)
                                i.borderColor = u.color;
                        });
                        this.setState({ list: j.list, originalList: j.list });
                    }
                });
                this.loadLegend(j.list);
            }
            else if (j.errorCode !== 0) {
                //this.alert(j.errorMessage);
                this.setState({ noAccess: true });
            }
        }, e => {
            this.alert(e.message);
        });
    }

    getPNInitials = (pn) => {
        if (!pn) return '';
        var p = pn.split(' ');

        var f = p[0].substr(0, 1);
        var l = p[1].substr(0, 1);

        return (f + l).toUpperCase();
    }

    renderEventContent(eventInfo) {
        let providerName = eventInfo.event.extendedProps?.providerName;
        let title = eventInfo.event.title;
        if (this.isMobile()) {
            let visit = this.state.list.find(a => a.id === Number(eventInfo.event.id));
            if (visit) {
                try {
                    let name = visit.patient.firstName.substr(0, 1) + '. ';
                    if (visit.patient.lastName.length > 3)
                        name += visit.patient.lastName.substr(0, 3);
                    else
                        name += visit.patient.lastName;
                    title = name;
                }
                catch { }
            }
        }
        return <div role="button" style={{ color: eventInfo.textColor, textDecoration: eventInfo.event.extendedProps.canceled ? 'line-through' : null }} className={
            [
                eventInfo.event.extendedProps.assignedToUserID === this.state.user.id ? 'my-event' : null,
                eventInfo.event.extendedProps.canceled ? 'text-muted' : null
            ].join(' ')}>
            {!this.isMobile() ? <b>{eventInfo.timeText}</b> : null}
            {eventInfo.event.extendedProps.isPlacement && Auth.hasRole('manager') && <> <Icon icon="faBandage" className="text-muted" /> </>}
            <i>{title}</i> <span className="pn-initials">{this.getPNInitials(providerName)}</span>
        </div>;
    }

    onDatesSet(dateInfo) {
        this.load(dateInfo.start, dateInfo.end);
        if (dateInfo.view.type === 'dayGridMonth') {
            qreq.post('/api/visit/calendar/date/set', { startDate: Globals.toISODateString(dateInfo.start) }, j => { });
        }
        qreq.post('/api/visit/calendar/view/set', { view: dateInfo.view.type }, j => { });
    }

    eventClick(info) {
        this.props.navigate('/visit/view/' + info.event.id);
    }

    calculateDistance(x1, y1, x2, y2) {
        return Math.sqrt(Math.exp(x2 - x1) + Math.exp(y2 - y1)) * 55.051;
    }

    onFilterChange(v, name) {
        var city = this.state.filter.city;
        var distance = this.state.filter.distance;
        if (name === 'city')
            city = v;
        else if (name === 'distance')
            distance = v;
        if (city) {
            var find = this.state.cityList.find(a => a.id === city);
            var list = [];
            this.state.originalList.forEach(i => {
                if (i.city === city)
                    list.push(i);
                else if (find && distance) {
                    var delta = this.calculateDistance(i.lat, i.lng, find.lat, find.lng);
                    if (delta <= distance)
                        list.push(i);
                }
            });
            this.setState({ list: list });
        }
        else {
            this.setState({ list: [...this.state.originalList], filter: { ...this.state.filter, distance: 0 } });
        }
    }

    search(value) {
        if (!value || value.length < 1) {
            this.setState({ list: [...this.state.originalList], localFilter: { search: '' } });
            return;
        }
        var list = [];
        this.state.originalList.forEach(i => {
            if (i.patient.fullName.toLowerCase().indexOf(value.toLowerCase()) >= 0)
                list.push(i);
        });
        this.setState({ list: list, localFilter: { search: value } });
    }


    render() {

        if (this.state.noAccess)
            return <Alert>You have arrived to nowhere. Please contact UDHS Support if you ever see this.</Alert>

        if (!this.state.initialDate)
            return;


        const header = <h1>Calendar</h1>;

        if (!this.state.user)
            return <div className="container-fluid">{header}<LoadingAlert /></div>;

        return (
            <div className="c-dashboard">
                <div className="container-fluid">
                    {header}
                    <div>
                        <FormInput model={this.state.localFilter} type="text" name="search" label="Search" labelAsPlaceholder placeholder="Search" onChange={this.search} />
                    </div>
                    {this.isFilter() ? <div className="my-2 bg-light p-2 drop-shadow">
                        <div className="row">
                            <div className="col-md-8">
                                <FormInput model={this.state.filter} name="city" label="Filter by City" type="select" options={this.state.cityList} onChange={v => this.onFilterChange(v, 'city')} selectDefault="All Cities" />
                            </div>
                            <div className="col-md-4">
                                <FormInput model={this.state.filter} name="distance" label="Filter Radius" type="select" options={this.state.distanceList} onChange={v => this.onFilterChange(v, 'distance')} selectDefault="0 miles" disabled={this.state.filter.city ? false : true} />
                            </div>
                        </div>
                    </div> : null}
                    {this.state.initialView ? <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin]}
                        initialView={this.state.initialView}
                        initialDate={this.state.initialDate}
                        events={this.state.list}
                        eventContent={this.renderEventContent}
                        datesSet={this.onDatesSet}
                        eventClick={this.eventClick}
                        headerToolbar={{
                            left: "prev,next",
                            center: "title",
                            right: "dayGridMonth,timeGridWeek,timeGridDay"
                        }} height={this.state.calendarHeight} /> : ''}
                    <div className="py-3">
                        <h2>Legend</h2>
                        {this.state.users?.map(i => <span className="me-2" style={{ color: i.color }}><Icon icon="faSquare" /> {i.name}</span>)}
                        <span className="me-2" style={{ color: '#000000' }}><Icon icon="faSquare" /> Unassigned</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default withParamsAndNavigate(Calendar);